import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { CALYPSO } from 'HubStyleTokens/colors'; // HACK: This weird wrapper is purely to ensure that we don't pass shouldHighlight
// down to the underlying div. If we upgraded styled-components to support either
// transient props or the ignoreProps api we could use that, but sadly our repackage
// does not support it.

const Div = (_ref) => {
  let rest = _objectWithoutPropertiesLoose(_ref, ["shouldHighlight"]);

  return /*#__PURE__*/_jsx("div", Object.assign({}, rest));
};

const HeaderLeftBorder = styled(Div).withConfig({
  displayName: "HeaderLeftBorder",
  componentId: "sc-782s8g-0"
})(["flex-shrink:0;border-left:2px solid transparent;background:none;height:100%;position:relative;left:1px;", ""], ({
  shouldHighlight
}) => shouldHighlight ? `border-color: ${CALYPSO};` : '');
export default HeaderLeftBorder;